@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../constants/spacing.module.less';

.drawer-main-content {
  padding: @space-16 @space-16;
  margin: @space-16;
  background-color: var(--white);
  border: 1px solid var(--grey-300);
  border-radius: 8px;
  max-width: 1200px;
  width: 100%;
  align-self: center;
  gap: @space-24;
  font-size: 14px;
}

.drawer-content-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: @space-4 0;

  span {
    display: flex;
    align-items: center;
    gap: @space-4;
  }
}

.tote-icon {
  height: 12px;
  width: 12px;
  color: var(--blue-600);
  margin: 5px;
  cursor: pointer;
}

.warehouse-selector-field {
  display: flex;
  flex-flow: column nowrap;
  min-width: 300px;
}

.warehouse-selector-label {
  color: var(--default--text-color--17);
}
